module.exports = "https://coursera_assets.s3.amazonaws.com/images/0863edbdf8109b8db5de11f5a8056c3c.png";